import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SelectCheckBoxComponent } from './select-check-box.component';

@NgModule({
  declarations: [SelectCheckBoxComponent],
  imports: [CommonModule],
  exports: [SelectCheckBoxComponent]
})
export class SelectCheckBoxModule {}
